import React, { useState, useEffect, useMemo } from 'react';
import { Spin } from 'antd';
import { useMenuDataSimple } from '../../../hooks/useMenuDataSimple';
import { getNavigationMenu } from '../../../utils/menuDataConverter';
import { businessApi, BusinessItem } from '../../../services/businessService';
import BusinessContentRenderer from '../ShowcaseWebsite/BusinessContentRenderer';
import '../ShowcaseWebsite/business-guide-styles.css';
import './BusinessPage.css';

const BusinessPage: React.FC = () => {
  const { menuData } = useMenuDataSimple();
  
  // 获取导航菜单并找到当前路径对应的图标
  const navIcon = useMemo(() => {
    const navMenu = getNavigationMenu(menuData);
    const currentMenuItem = navMenu.find((item: { path: string }) => item.path === '/show/business' || item.path === 'show/business');
    return currentMenuItem?.icon || '&#xe6a6;'; // 默认使用数据库中的图标
  }, [menuData]);
  const [businessGuides, setBusinessGuides] = useState<BusinessItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedBusinessTab, setSelectedBusinessTab] = useState('patent-process');

  // 从API加载业务指南数据
  useEffect(() => {
    const loadBusinessGuides = async () => {
      setLoading(true);
      try {
        /*const response = await businessApi.getList({
          current: 1,
          size: 1000,
          status: '1'
        });*/
        const response = await businessApi.getAll({status: '0'});
        if (response.code === 200) {
          // getAll 返回的是 BusinessItem[]，直接使用 response.data
          const data = response.data || [];
          setBusinessGuides(data);
        } else {
          console.warn('业务指南数据加载失败，response.code:', response.code);
        }
      } catch (error) {
        console.error('加载业务指南数据失败:', error);
      } finally {
        setLoading(false);
      }
    };
    loadBusinessGuides();
  }, []);

  // 业务标签从字典或配置获取（替代硬编码）
  const businessTabs = [
    { key: 'patent-process', label: '知识产权业务办理流程' },
    { key: 'service-content', label: '服务内容' },
    { key: 'institution-process', label: '机构入驻流程' }
  ];

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" />
        <p style={{ marginTop: '16px' }}>加载中...</p>
      </div>
    );
  }

  return (
    <div className="business-page">
      <div className="business-layout">
        {/* 左侧功能列表 */}
        <div className="business-sidebar">
          <div className="sidebar-container">
            <div className="sidebar-header">
              <span className="icon-text">
                <i 
                  className="iconfont" 
                  dangerouslySetInnerHTML={{ __html: navIcon }}
                ></i>
                <span>业务指南</span>
              </span>
              <div className="header-arrow">▼</div>
            </div>
            <div className="sidebar-menu">
              {businessTabs.map(tab => (
                <div
                  key={tab.key}
                  className={`menu-item ${selectedBusinessTab === tab.key ? 'active' : ''}`}
                  onClick={() => setSelectedBusinessTab(tab.key)}
                >
                  <span className="icon-text">
                    <i className="iconfont icon-quanlingyuguimo"></i>
                    <span>{tab.label}</span>
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* 右侧内容区 */}
        <div className="business-main">
          <BusinessContentRenderer 
            selectedBusinessTab={selectedBusinessTab}
            businessGuides={businessGuides}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
};

export default BusinessPage;


